<template>
  <div class="update-password-page-wrapper">
    <!-- 装饰背景光晕层 (来自 LoginView) -->
    <div class="bg-glow-layer" aria-hidden="true">
      <div class="bg-blob bg-blob-blue"></div>
      <div class="bg-blob bg-blob-orange"></div>
      <div class="bg-grid-overlay"></div>
    </div>

    <!-- 主内容区：居中卡片 -->
    <div class="main-content">
      <div class="auth-split-shell">
        <div class="form-card-container">
          <el-card class="form-card" shadow="always">
            <div class="card-body">
              <div class="card-inner">
                <!-- 头部 -->
                <div class="form-header">
                  <div class="header-eyebrow">安全验证</div>
                  <h3>找回密码</h3>
                  <p class="header-sub">通过绑定的手机号重置您的密码</p>
                </div>

                <!-- 表单  -->
                <el-form
                    ref="forgotFormRef"
                    :model="forgotForm"
                    :rules="forgotRules"
                    class="password-form"
                >
                  <el-form-item prop="phone">
                    <el-input
                        v-model="forgotForm.phone"
                        maxlength="11"
                        placeholder="请输入手机号"
                        size="large"
                        class="elegant-input"
                        clearable
                        @focus="clearFieldError('phone')"
                    >
                      <template #prefix>
                        <el-icon><Iphone /></el-icon>
                      </template>
                    </el-input>
                  </el-form-item>

                  <el-form-item prop="verifyCode">
                    <el-input
                        v-model="forgotForm.verifyCode"
                        maxlength="6"
                        placeholder="请输入验证码"
                        size="large"
                        class="elegant-input has-suffix"
                        @focus="clearFieldError('verifyCode')"
                    >
                      <template #prefix>
                        <el-icon><Message /></el-icon>
                      </template>
                      <template #suffix>
                        <el-button
                            link
                            class="captcha-btn"
                            :disabled="countdown > 0"
                            @click="sendVerifyCode"
                        >
                          {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
                        </el-button>
                      </template>
                    </el-input>
                  </el-form-item>

                  <el-form-item prop="newPassword">
                    <el-input
                        v-model="forgotForm.newPassword"
                        type="password"
                        placeholder="请输入新密码（至少8位，含字母和数字）"
                        size="large"
                        class="elegant-input"
                        show-password
                        @focus="clearFieldError('newPassword')"
                    >
                      <template #prefix>
                        <el-icon><Lock /></el-icon>
                      </template>
                    </el-input>
                  </el-form-item>

                  <el-form-item prop="confirmPassword">
                    <el-input
                        v-model="forgotForm.confirmPassword"
                        type="password"
                        placeholder="请确认新密码"
                        size="large"
                        class="elegant-input"
                        show-password
                        @focus="clearFieldError('confirmPassword')"
                    >
                      <template #prefix>
                        <el-icon><Lock /></el-icon>
                      </template>
                    </el-input>
                  </el-form-item>

                  <el-form-item>
                    <el-button
                        type="primary"
                        size="large"
                        class="submit-btn"
                        :loading="submitting"
                        @click="handleForgotPassword"
                    >
                      重置密码
                    </el-button>
                  </el-form-item>
                </el-form>

                <!-- 底部链接 -->
                <div class="footer-links">
                  <el-link type="info" @click="backToLogin" class="back-link" :underline="false">
                    <el-icon><ArrowLeft /></el-icon>
                    返回登录
                  </el-link>
                </div>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>

    <!-- 底部版权信息 (完全复用 LoginView 底部) -->
    <el-footer class="login-footer" height="auto">
      <div class="footer-glow footer-glow-blue" aria-hidden="true"></div>
      <div class="footer-glow footer-glow-orange" aria-hidden="true"></div>
      <div class="footer-content">
        <div class="footer-main">
          <div class="footer-sections">
            <!-- 网站介绍 -->
            <div class="footer-section">
              <h4 class="section-title footer-logo-text">易印工具</h4>
              <p class="footer-desc">
                专业的印前设计工具，让设计更加高效精准。我们致力于为各行业提供最优质的印前解决方案。
              </p>
            </div>

            <!-- 联系方式 -->
            <div class="footer-section">
              <h4 class="section-title">联系方式</h4>
              <div class="contact-info">
                <div class="contact-item">
                  <el-icon><Message /></el-icon>
                  <span>3052594895@qq.com</span>
                </div>
                <div class="contact-item">
                  <el-icon><Phone /></el-icon>
                  <span>18925330037</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 底部版权信息 -->
          <div class="footer-bottom">
            <div class="copyright-section">
              <div class="copyright-text">
                © 2026 中山市易印网络科技有限公司.保留所有权利.
              </div>
            </div>
            <div class="certification-info">
              <div class="beian-container">
                <img src="/eprinttools-files/front-end/police.png" alt="公安备案图标" class="beian-icon">
                <a href="http://www.beian.gov.cn" target="_blank" class="beian-link">
                  粤公网安备 44200002443702号
                </a>
                <span class="divider">|</span>
                <a href="https://beian.miit.gov.cn/" target="_blank" class="icp-link">
                  粤ICP备16014837号
                </a>
              </div>
              <div class="legal-links">
                <a href="#" @click.prevent="showPrivacyDialog" class="legal-link">隐私政策</a>
                <span class="divider">|</span>
                <a href="#" @click.prevent="showTermsDialog" class="legal-link">用户协议</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-footer>
  </div>

  <!-- 服务条款弹窗 -->
  <el-dialog
      v-model="termsDialogVisible"
      :title="null"
      width="60%"
      top="8vh"
      class="policy-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <template #header>
      <div class="dialog-header">
        <div class="dialog-header-icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M14 2v6h6M9 13h6M9 17h6" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <h3>用户协议</h3>
          <p>请仔细阅读以下条款</p>
        </div>
      </div>
    </template>
    <div class="dialog-content" v-html="termsContent"></div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="termsDialogVisible = false">关闭</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- 隐私政策弹窗 -->
  <el-dialog
      v-model="privacyDialogVisible"
      :title="null"
      width="60%"
      top="8vh"
      class="policy-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <template #header>
      <div class="dialog-header">
        <div class="dialog-header-icon">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9 12l2 2 4-4" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <h3>隐私政策</h3>
          <p>我们如何保护您的个人信息</p>
        </div>
      </div>
    </template>
    <div class="dialog-content" v-html="privacyContent"></div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="privacyDialogVisible = false">关闭</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { Iphone, Message, Lock, ArrowLeft, Phone } from '@element-plus/icons-vue'
import request from '@/utils/request'

const router = useRouter()

// ---------- 弹窗控制 ----------
const termsDialogVisible = ref(false)
const privacyDialogVisible = ref(false)

const termsContent = ref(`
  <h2>易比图工具用户协议</h2>
  <p><strong>版本日期：2025年8月26日</strong></p>
  <p>本协议是您（以下简称"用户"）与易印公司（以下简称"本公司"）就使用易比图工具（以下简称"本软件"）服务所订立的协议。请您在注册、下载、安装或使用本软件及相关服务前，仔细阅读并充分理解本协议。</p>
  <h3>1. 服务内容</h3>
  <ul>
    <li>本软件提供屏幕截图图片比对与差异显示功能，主要用于包装印刷等视觉校对场景。</li>
    <li>本软件的比对结果仅供参考，最终决定应由用户自行或由专业人员确认。</li>
  </ul>
  <h3>2. 使用规范</h3>
  <ul>
    <li>用户不得将本软件用于任何违法、侵权或未经授权的用途。</li>
    <li>用户在使用本软件过程中产生的所有行为及后果，由用户自行承担。</li>
    <li>用户应自行做好数据备份和安全防护。</li>
  </ul>
  <h3>3. 知识产权</h3>
  <ul>
    <li>本软件及其全部内容，包括但不限于代码、界面设计、图标（含SVG图标）、文字、图像等，均受著作权法及相关法律保护，归本公司所有。</li>
    <li>未经本公司书面许可，用户不得复制、修改、出售、反向工程或以其他方式使用本软件的全部或部分内容。</li>
  </ul>
  <h3>4. 免责声明与责任限制</h3>
  <ul>
    <li>因用户依赖比对结果造成的任何直接或间接损失，本公司不承担责任。</li>
    <li>因不可抗力（包括但不限于自然灾害、网络故障、系统故障）导致的服务中断或数据丢失，本公司不承担责任。</li>
  </ul>
  <h3>5. 服务变更与终止</h3>
  <ul>
    <li>本公司保留随时修改、暂停或终止全部或部分服务的权利，并将在官网公告或通过适当方式提前通知用户。</li>
    <li>用户有权随时停止使用本软件。</li>
  </ul>
  <h3>6. 法律适用与争议解决</h3>
  <ul>
    <li>本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。</li>
    <li>双方因本协议产生的争议，应友好协商解决；协商不成的，应提交至本公司所在地人民法院诉讼解决。</li>
  </ul>
`)

const privacyContent = ref(`
  <h2>易比图工具隐私政策</h2>
  <p><strong>版本日期：2025年8月26日</strong></p>
  <p>本隐私政策旨在说明本公司在您使用本软件及相关服务过程中，如何收集、使用、存储和保护您的个人信息。</p>
  <h3>1. 信息收集</h3>
  <ul>
    <li><strong>注册信息</strong>：包括姓名、邮箱、联系电话等（如适用）。</li>
    <li><strong>使用数据</strong>：包括软件功能使用频率、比对任务类型、错误日志（不含比对图片内容本身）。</li>
    <li><strong>设备信息</strong>：包括操作系统类型、版本号、硬件型号等。</li>
  </ul>
  <h3>2. 信息使用</h3>
  <ul>
    <li>提供、维护和优化本软件的功能与性能。</li>
    <li>为用户提供技术支持与更新通知。</li>
    <li>在用户同意的情况下，用于发送产品资讯或营销活动信息。</li>
  </ul>
  <h3>3. 信息存储与保护</h3>
  <ul>
    <li>本公司采取符合行业标准的安全措施保护用户数据，防止未经授权的访问、披露、篡改或毁坏。</li>
    <li>除法律法规另有规定外，本公司仅在为实现本政策所述目的所必需的期限内保存用户信息。</li>
  </ul>
  <h3>4. 信息共享</h3>
  <ul>
    <li>本公司不会向第三方出售或出租用户信息。</li>
    <li>仅在以下情况下共享用户信息：
      <ul>
        <li>获得用户事先同意；</li>
        <li>法律法规或政府机关要求；</li>
        <li>为维护本公司合法权益所必需。</li>
      </ul>
    </li>
  </ul>
  <h3>5. 用户权利</h3>
  <ul>
    <li>用户可随时访问、更正或删除其个人信息（法律法规另有规定的除外）。</li>
    <li>用户可撤回同意，但可能会影响某些功能的使用。</li>
  </ul>
  <h3>6. 政策更新</h3>
  <ul>
    <li>本公司可能会不时更新本政策，并通过官网或其他适当方式通知用户。</li>
    <li>更新后的政策自发布之日起生效。</li>
  </ul>
`)

const showTermsDialog = () => { termsDialogVisible.value = true }
const showPrivacyDialog = () => { privacyDialogVisible.value = true }

// ---------- 表单数据 ----------
const forgotForm = reactive({
  phone: '',
  verifyCode: '',
  newPassword: '',
  confirmPassword: ''
})

const forgotFormRef = ref()
const countdown = ref(0)
const timer = ref(null)
const submitting = ref(false)

// 用于清除特定字段的错误（用户输入时消除错误状态）
const clearFieldError = (field) => {
  if (forgotFormRef.value) {
    forgotFormRef.value.clearValidate(field)
  }
}

// ---------- 验证规则 ----------
const forgotRules = {
  phone: [
    { required: true, message: '请输入手机号', trigger: ['blur', 'change'] },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: ['blur', 'change'] }
  ],
  verifyCode: [
    { required: true, message: '请输入验证码', trigger: ['blur', 'change'] },
    { pattern: /^\d{6}$/, message: '验证码应为6位数字', trigger: ['blur', 'change'] }
  ],
  newPassword: [
    { required: true, message: '请输入新密码', trigger: ['blur', 'change'] },
    { min: 8, message: '密码长度至少8位', trigger: ['blur', 'change'] },
    {
      pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
      message: '密码至少包含字母和数字',
      trigger: ['blur', 'change']
    }
  ],
  confirmPassword: [
    { required: true, message: '请确认新密码', trigger: ['blur', 'change'] },
    {
      validator: (rule, value, callback) => {
        if (value !== forgotForm.newPassword) {
          callback(new Error('两次输入的密码不一致'))
        } else {
          callback()
        }
      },
      trigger: ['blur', 'change']
    }
  ]
}

// ---------- 发送验证码 ----------
const sendVerifyCode = async () => {
  if (!forgotFormRef.value) return

  try {
    await forgotFormRef.value.validateField('phone')
  } catch {
    return
  }

  try {
    await request.get('/auth/verify-code/phone', {
      params: {
        phone: forgotForm.phone,
        scene: 'Bind'
      }
    })
    ElMessage.success('验证码发送成功')
    startCountdown()
  } catch (error) {
    ElMessage.error(error.response?.data?.message || '验证码发送失败')
  }
}

// ---------- 倒计时 ----------
const startCountdown = () => {
  countdown.value = 60
  timer.value = setInterval(() => {
    countdown.value--
    if (countdown.value <= 0) {
      clearInterval(timer.value)
    }
  }, 1000)
}

// ---------- 重置密码提交 ----------
const handleForgotPassword = async () => {
  if (!forgotFormRef.value || submitting.value) return

  try {
    await forgotFormRef.value.validate()
  } catch {
    return
  }

  submitting.value = true
  try {
    const { confirmPassword, ...submitData } = forgotForm
    await request.post('/auth/forgot-password', submitData)
    ElMessage.success('密码重置成功，请重新登录')
    router.push('/login')
  } catch (error) {
    ElMessage.error(error.response?.data?.message || '密码重置失败，请稍后重试')
  } finally {
    submitting.value = false
  }
}

// ---------- 返回登录 ----------
const backToLogin = () => {
  router.push('/login')
}

// ---------- 清理定时器 ----------
const clearTimer = () => {
  if (timer.value) {
    clearInterval(timer.value)
    timer.value = null
  }
}

onUnmounted(() => {
  clearTimer()
})
</script>

<style scoped lang="scss">
/* ============================================================
   1. 根容器 & 背景光晕 (来自 LoginView)
   ============================================================ */
.update-password-page-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  background: radial-gradient(ellipse 900px 700px at 12% 5%, rgba(47, 91, 255, 0.12), transparent 60%),
  radial-gradient(ellipse 800px 600px at 88% 8%, rgba(245, 158, 11, 0.08), transparent 55%),
  radial-gradient(ellipse 700px 500px at 50% 100%, rgba(47, 91, 255, 0.05), transparent 55%),
  #f7f9fc;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Microsoft YaHei', sans-serif;
  overflow-x: hidden;
}

.bg-glow-layer {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;

  .bg-blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(80px);
    opacity: 0.5;
    animation: floatBlob 18s ease-in-out infinite;
  }

  .bg-blob-blue {
    width: 520px;
    height: 520px;
    top: -120px;
    left: -100px;
    background: radial-gradient(circle, rgba(47, 91, 255, 0.45), transparent 70%);
  }

  .bg-blob-orange {
    width: 460px;
    height: 460px;
    top: 10%;
    right: -120px;
    background: radial-gradient(circle, rgba(245, 158, 11, 0.4), transparent 70%);
    animation-delay: -6s;
  }

  .bg-grid-overlay {
    position: absolute;
    inset: 0;
    background-image: linear-gradient(rgba(47, 91, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(47, 91, 255, 0.04) 1px, transparent 1px);
    background-size: 48px 48px;
    mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 75%);
    -webkit-mask-image: radial-gradient(ellipse 80% 60% at 50% 30%, #000 30%, transparent 75%);
  }
}

/* ============================================================
   2. 主内容区：卡片居中
   ============================================================ */
.main-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  box-sizing: border-box;
  padding: 0;     /* 右侧保留 5% 安全间距，避免卡片贴边 */
}

.auth-split-shell {
  width: 100%;
  max-width: 380px;
}

.form-card-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-card {
  width: 100%;
  border-radius: 20px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(20px);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.1),
  0 6px 20px rgba(47, 91, 255, 0.08),
  inset 0 1px 0 rgba(255, 255, 255, 0.6);
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  overflow: hidden;

  &:hover {
    box-shadow: 0 24px 60px rgba(15, 23, 42, 0.14),
    0 8px 28px rgba(47, 91, 255, 0.12);
  }

  :deep(.el-card__body) {
    padding: 0 !important;
    border-radius: 20px;
    overflow: hidden;
  }
}

.card-body {
  padding: 0 !important;
  margin: 0 !important;
  display: flex;
}

.card-inner {
  flex: 1;
  padding: 28px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: auto;
}

/* ============================================================
   3. 头部
   ============================================================ */
.form-header {
  margin-bottom: 24px;
  text-align: left;

  .header-eyebrow {
    display: inline-block;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #2f5bff;
    background: rgba(47, 91, 255, 0.08);
    padding: 4px 12px;
    border-radius: 999px;
    border: 1px solid rgba(47, 91, 255, 0.15);
    margin-bottom: 10px;
  }

  h3 {
    font-size: 1.6rem;
    font-weight: 800;
    margin: 0 0 6px;
    background: linear-gradient(135deg, #0f172a 0%, #142c84 55%, #1f43cc 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    letter-spacing: -0.5px;
    line-height: 1.2;
  }

  .header-sub {
    margin: 0;
    font-size: 0.88rem;
    color: #64748b;
    font-weight: 400;
  }
}

/* ============================================================
   4. 表单 (参考 PasswordUpdateDialog)
   ============================================================ */
.password-form {
  min-height: 220px;
  margin: 0 !important;
  flex-direction: column;
  justify-content: flex-start;
}

:deep(.el-form-item) {
  margin-bottom: 18px;
}

/* ---- 优雅输入框 (圆角 12px + 蓝色 focus 光晕) ---- */
.elegant-input {
  :deep(.el-input__wrapper) {
    border-radius: 12px;
    padding: 1px 14px;
    box-shadow: 0 0 0 1px rgba(226, 232, 240, 0.9) inset;
    height: 32px;
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
    background: rgba(248, 250, 252, 0.4);

    &:hover {
      box-shadow: 0 0 0 1px #cbd5e1 inset;
      background: #fff;
    }

    &.is-focus {
      box-shadow: 0 0 0 1px #2f5bff inset,
      0 0 0 4px rgba(47, 91, 255, 0.12) !important;
      background: #fff;
    }
  }

  :deep(.el-input__prefix) {
    left: 12px;
    color: #2f5bff;

    .el-icon {
      font-size: 18px;
    }
  }

  :deep(.el-input__suffix) {
    display: flex;
    align-items: center;
    padding-right: 10px;
  }

  :deep(.el-input__inner) {
    color: #1e293b;
    font-size: 14px;

    &::placeholder {
      color: #94a3b8;
      font-size: 12px;
    }

    &.has-suffix {
      :deep(.el-input__inner) {
        padding-right: 90px;   // ✅ 仅此一处
      }
    }
  }

  .captcha-btn {
    padding: 0;
    height: auto;
    color: #2f5bff;
    font-size: 0.82rem;
    font-weight: 600;
    white-space: nowrap;
    margin-left: 4px;
    transition: color 0.25s ease;

    &:hover:not(:disabled) {
      color: #f59e0b;
    }

    &:disabled {
      color: #94a3b8;
      cursor: not-allowed;
    }
  }

  :deep(input) {
    font-size: 14px;
    height: 16px;
    line-height: 36px;

    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
      -webkit-text-fill-color: #1e293b !important;
      -webkit-box-shadow: 0 0 0px 1000px white inset !important;
      transition: background-color 5000s ease-in-out 0s;
    }
  }
}

/* ---- 重置按钮 (渐变蓝) ---- */
.submit-btn {
  width: 100%;
  margin-top: 8px;
  border-radius: 12px;
  padding: 0 16px;
  font-weight: 700;
  letter-spacing: 3px;
  font-size: 14px;
  height: 46px;
  border: none;
  background: linear-gradient(135deg, #2f5bff 0%, #5b7cff 100%) !important;
  box-shadow: 0 8px 20px rgba(47, 91, 255, 0.35),
  inset 0 1px 0 rgba(255, 255, 255, 0.2);
  transition: all 0.35s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.25), transparent);
    transition: left 0.6s ease;
  }

  &:hover:not(.is-loading) {
    transform: translateY(-2px);
    box-shadow: 0 14px 28px rgba(47, 91, 255, 0.42),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);

    &::before {
      left: 100%;
    }
  }

  &:active:not(.is-loading) {
    transform: translateY(0);
  }
}

/* ---- 底部链接 ---- */
.footer-links {
  text-align: center;
  padding-top: 18px;
  border-top: 1px solid rgba(226, 232, 240, 0.9);
  margin-top: 4px;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #64748b;
  transition: color 0.3s ease;

  .el-icon {
    display: inline-flex;      // 或 flex
    align-items: center;
    justify-content: center;
    line-height: 1;            // 消除行高带来的偏移
    font-size: 16px;           // 图标大小不变
    vertical-align: middle;    // 辅助对齐
  }

  &:hover {
    color: #1f43cc !important;
    text-decoration: none !important;
  }
}

/* ============================================================
   5. 底部 Footer (完全复用 LoginView)
   ============================================================ */
.login-footer {
  position: relative;
  color: #475569;
  flex-shrink: 0;
  padding: 16px 24px 12px;
  border-top: 1px solid rgba(226, 232, 240, 0.8);
  overflow: hidden;
  background: linear-gradient(135deg, #e8edf2 0%, #f2f0f2 45%, #f8f4f0 100%);

  .footer-glow {
    display: none;
  }

  .footer-content {
    position: relative;
    z-index: 1;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 62px 62px;
  }

  .footer-sections {
    background: transparent;
    display: grid;
    grid-template-columns: 1.5fr 1fr;
    gap: 42px;
    margin-bottom: 10px;
  }

  .footer-section:first-child {
    padding-right: 10px;
  }

  .footer-logo-text {
    font-size: 1.2rem;
    font-weight: 700;
    color: #1e293b;
    background: linear-gradient(135deg, #2f5bff, #f59e0b);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .footer-desc {
    background: transparent;
    color: #64748b;
    line-height: 1.7;
    font-size: 0.88rem;
    margin: 0;
  }

  .section-title {
    color: #1e293b;
    font-size: 1rem;
    font-weight: 700;
    margin: 0 0 8px;
    position: relative;
    display: inline-block;
  }

  .contact-info {
    background: transparent;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px 24px;
  }

  .contact-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    white-space: nowrap;

    &:hover {
      color: #1e293b;
    }

    .el-icon {
      color: #f59e0b;
      font-size: 1rem;
    }
  }

  .footer-bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 8px 16px;
    padding-top: 8px;
    border-top: 1px solid rgba(141, 143, 146, 0.6);
  }

  .copyright-section {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .copyright-text {
    font-size: 0.8rem;
    color: #94a3b8;
  }

  .legal-links {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .legal-link {
    color: #94a3b8;
    text-decoration: none;
    font-size: 0.82rem;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      color: #1f43cc;
    }
  }

  .divider {
    color: #cbd5e1;
    font-size: 0.78rem;
  }

  .certification-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .beian-container {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .beian-icon {
    height: 16px;
    width: auto;
    filter: brightness(0.9);
  }

  .beian-link,
  .icp-link {
    color: #94a3b8;
    text-decoration: none;
    font-size: 0.78rem;
    transition: color 0.3s ease;

    &:hover {
      color: #1f43cc;
    }
  }
}

/* ============================================================
   6. 政策弹窗 (复用 LoginView 风格)
   ============================================================ */
.policy-dialog {
  :deep(.el-dialog) {
    width: 560px !important;
    max-width: 92%;
    border-radius: 20px;
    overflow: hidden;
    max-height: 84vh;
    display: flex;
    flex-direction: column;
    margin-top: 8vh !important;
    box-shadow: 0 32px 64px rgba(15, 23, 42, 0.25),
    0 12px 24px rgba(47, 91, 255, 0.12);
    border: 1px solid rgba(226, 232, 240, 0.9);
  }

  :deep(.el-dialog__header) {
    padding: 0;
    margin: 0;
    border-bottom: none;
    position: relative;
    background: radial-gradient(ellipse 400px 200px at 10% 0%, rgba(47, 91, 255, 0.14), transparent 70%),
    radial-gradient(ellipse 400px 200px at 90% 0%, rgba(245, 158, 11, 0.1), transparent 70%),
    linear-gradient(135deg, #f7f9fc 0%, #ffffff 100%);
    border-bottom: 1px solid rgba(226, 232, 240, 0.9);

    .dialog-header {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 22px 26px;

      .dialog-header-icon {
        width: 44px;
        height: 44px;
        border-radius: 12px;
        background: linear-gradient(135deg, #2f5bff, #5b7cff);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 20px rgba(47, 91, 255, 0.3);
        flex-shrink: 0;
      }

      h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
        line-height: 1.3;
      }

      p {
        margin: 4px 0 0;
        font-size: 12.5px;
        color: #64748b;
      }
    }
  }

  :deep(.el-dialog__body) {
    padding: 0;
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  :deep(.el-dialog__footer) {
    padding: 14px 24px;
    border-top: 1px solid rgba(226, 232, 240, 0.9);
    background: #f7f9fc;
  }

  :deep(.el-dialog__headerbtn) {
    top: 16px;
    right: 16px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(8px);
    transition: all 0.3s ease;

    &:hover {
      background: rgba(220, 38, 38, 0.1);

      .el-dialog__close {
        color: #dc2626;
      }
    }
  }
}

.dialog-content {
  flex: 1;
  overflow-y: auto;
  line-height: 1.75;
  color: #475569;
  padding: 22px 26px;
  max-height: 56vh;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.35);
    border-radius: 3px;

    &:hover {
      background: rgba(47, 91, 255, 0.4);
    }
  }

  h2 {
    color: #0f172a;
    margin: 0 0 12px;
    padding-bottom: 12px;
    border-bottom: 2px solid transparent;
    border-image: linear-gradient(90deg, #2f5bff, #f59e0b) 1;
    font-size: 1.35em;
    font-weight: 700;
  }

  h3 {
    color: #1e293b;
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 1.05em;
    font-weight: 700;
    padding-left: 10px;
    border-left: 3px solid #2f5bff;
  }

  p,
  ul {
    margin-bottom: 12px;
    font-size: 14px;
  }

  ul {
    padding-left: 20px;

    li {
      margin-bottom: 6px;
    }
  }

  strong {
    color: #1e293b;
    font-weight: 600;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;

  :deep(.el-button--primary) {
    background: linear-gradient(135deg, #2f5bff, #5b7cff);
    border: none;
    border-radius: 10px;
    padding: 9px 22px;
    font-weight: 600;
    box-shadow: 0 6px 16px rgba(47, 91, 255, 0.3);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 8px 20px rgba(47, 91, 255, 0.4);
    }
  }
}

/* ============================================================
   7. 关键帧动画
   ============================================================ */
@keyframes floatBlob {
  0%, 100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(20px, -30px) scale(1.05);
  }
  66% {
    transform: translate(-15px, 20px) scale(0.95);
  }
}

/* ============================================================
   8. 响应式
   ============================================================ */
@media (max-width: 1024px) {
  .auth-split-shell {
    max-width: 420px;
  }

  .card-inner {
    padding: 28px 26px 22px;
  }
}

@media (max-width: 768px) {
  .update-password-page-wrapper {
    min-height: 100vh;
    height: auto;
  }

  .main-content {
    padding: 24px 16px 20px;
    min-height: auto;
  }

  .auth-split-shell {
    max-width: 100%;
  }

  .card-inner {
    padding: 22px 18px 18px;
  }

  .form-header {
    text-align: center;
    margin-bottom: 20px;

    .header-eyebrow {
      font-size: 0.72rem;
    }

    h3 {
      font-size: 1.4rem;
    }

    .header-sub {
      font-size: 0.82rem;
    }
  }

  .elegant-input {
    :deep(.el-input__wrapper) {
      height: 42px;
    }
  }

  .submit-btn {
    height: 42px;
    font-size: 14px;
  }

  .login-footer {
    padding: 8px 12px 6px;
  }

  .login-footer .footer-content {
    padding: 12px 0;
  }

  .login-footer .footer-sections {
    grid-template-columns: 1fr;
    gap: 12px;
    margin-bottom: 8px;
  }

  .login-footer .footer-bottom {
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding-top: 4px;
    border-top: 1px solid rgba(226, 232, 240, 0.6);
  }

  .login-footer .contact-info {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px 16px;
  }

  .login-footer .certification-info {
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .login-footer .beian-container {
    justify-content: center;
  }

  .login-footer .copyright-text {
    font-size: 0.75rem;
  }

  .login-footer .beian-link,
  .login-footer .icp-link {
    font-size: 0.7rem;
  }

  .policy-dialog {
    :deep(.el-dialog) {
      width: 92% !important;
      margin-top: 4vh !important;
      max-height: 90vh;
    }

    :deep(.el-dialog__header .dialog-header) {
      padding: 16px 18px;

      .dialog-header-icon {
        width: 36px;
        height: 36px;
      }

      h3 {
        font-size: 16px;
      }
    }
  }

  .dialog-content {
    padding: 16px 18px;
    max-height: 50vh;
  }
}

@media (max-width: 480px) {
  .auth-split-shell {
    max-width: 100%;
  }

  .card-inner {
    padding: 16px 14px 14px;
  }

  .form-header h3 {
    font-size: 1.2rem;
  }

  .elegant-input {
    :deep(.el-input__wrapper) {
      height: 38px;
      padding: 1px 10px;
    }

    :deep(.el-input__inner) {
      font-size: 13px;
      padding-right: 70px;
    }

    .captcha-btn {
      font-size: 0.75rem;
    }
  }

  .submit-btn {
    height: 38px;
    font-size: 13px;
    letter-spacing: 2px;
  }

  .back-link {
    font-size: 13px;
  }
}
</style>